"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const BSRUpload = createSVGIcon(
  <path
    d="M21.25 14.25v7H2.75v-7M12 18V3.125m6.5 6.71L12 3.125l-6.5 6.71"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
  />,
  "BSRUpload",
  (strictLocalize) => ({
    className: iconCls(),
    color: iconColor.primary,
    fill: "none",
    titleAccess: strictLocalize({
      id: "4YSa2T",
      defaultMessage: "Upload",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    viewBox: "0 0 24 24",
  })
);
